export const POPUP_WIDTH = 270;
export const POPUP_WIDTH_HALF = POPUP_WIDTH / 2;
export const POPUP_HEIGHT = 210;
export const POPUP_HEIGHT_HALF = POPUP_HEIGHT / 2;

export const POPUP_DEFAULT_OPTIONS = {
  closeButton: false,
};
